var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('label',{staticClass:"switch",class:_vm.value && 'activated'},[_c('input',{ref:"check-input",attrs:{"type":"checkbox"},on:{"input":_vm.handleCheck}}),_c('span',{staticClass:"slide round"}),_c('span',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }